
<template>
    <div class="science-news-box">
        <!--
            How I imagine this being used:
            <science-news-box 
                :heading="String Title" 
                :description="String Description" 
                :link="{text: 'string link text', url: 'string link URL'}"
                >

                <p>Any single component get slid into a slot here, instead of this paragraph</p>

            </science-news-box>
        -->
        <div 
        v-if="heading" 
        class="container container-fluid">
            <div class="science-news-box__container phd--shadow-border">
                <div class="row">
                    <div class="col-12 col-md-8 col-lg-9 order-1">
                        <div
                            class="h2 science-news-box__heading"
                            role="heading"
                            :aria-level="headingLevel"
                            v-html="heading">Heading Goes Here</div>
                        
                        <p 
                            v-if="description"
                            class="title-description science-news-box__description" 
                            v-html="description">Description Goes Here</p>
                    </div>

                    <div 
                        v-if="link.url && link.text"
                        class="col-12 col-md-4 col-lg-3 order-2 d-none d-md-block 
                        science-news-box__link-container">
                        <a 
                            :href="link.url" 
                            v-html="link.text" 
                            class="c-cta c-cta--arrow view-all-link science-news-box__link">link text here</a>
                    </div>

                    <div class="col-12 order-2 order-md-3 science-news-box__content">
                        <slot><p>If you're seeing this message, you need to slot something into this component.</p></slot>
                    </div>

                    <div 
                        v-if="link.url && link.text"
                        class="col-12 col-md-4 col-lg-3 order-3 d-md-none 
                        science-news-box__link-container">
                        <a 
                            :href="link.url" 
                            v-html="link.text" 
                            class="c-cta c-cta--arrow view-all-link science-news-box__link">link text here</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            heading: {
                type: String,
                required: true
            },
            headingLevel: {
                type: String,
                default: "1"
            },
            description: {
                type: String,
                required: false
            },
            link: {
                type: Object,
                required: false
            }
        },
        data() {
            return {}
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/components/phd/science-news-box.vue